(() => {
  const LINES = [
    "DHL Express shipping to all the US",
    "Full insurance covered",
    "US import duties included",
  ];

  function anchors() {
    return Array.from(
      document.querySelectorAll(
        '[name="checkout"], #checkout, .cart__checkout-button, shopify-accelerated-checkout-cart, button[name="checkout"]'
      )
    );
  }

  function place() {
    const nodes = anchors();
    if (!nodes.length) return;
    const first = nodes[0];
    const host =
      first.closest(".cart__ctas, .cart-drawer__footer, .cart__footer, .cart-drawer__summary, .cart-summary") ||
      first.parentElement;
    if (!host || host.querySelector("[data-es-duties]")) return;
    const list = document.createElement("ul");
    list.className = "es-cart-duties";
    list.setAttribute("data-es-duties", "");
    for (const line of LINES) {
      const item = document.createElement("li");
      item.textContent = line;
      list.appendChild(item);
    }
    host.insertBefore(list, first);
  }

  function start() {
    place();
    const observer = new MutationObserver(place);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
